import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class CoachingCoacheeCohortGoalsGoalController extends Controller {
  queryParams = ['edit'];

  @tracked edit: string | null = null;

  get startInEdit(): boolean {
    return this.edit === 'true';
  }
}
